import {
  ACR,
  Amazon,
  Antigravity,
  AsanaLogo,
  AzureBoardsLogo,
  AzureRepos,
  Bitbucket,
  CircleCI,
  ClaudeColored,
  Codex,
  Cursor,
  DockerHub,
  ExclamationCircleFilled,
  GCR,
  GeminiCli,
  GitHubCopilot,
  GithubActions,
  Gitlab,
  IntegrationGitHub,
  IntegrationInstallationStatus,
  IntegrationJira,
  IntegrationWebhook,
  Jenkins,
  JetBrains,
  KodemCI,
  KodemCLI,
  KodemMCP,
  LoadingOutlined,
  PackageRegistry,
  ServiceNow,
  Slack,
  Splunk,
  VSCode,
  VisualStudio,
  Wiz
} from "@/icons"
import cn from "classnames"

import { isUnhealthy } from "@/domain/integration"
import { HealthWarning } from "@/pages/IntegrationsPage/components/molecules/HealthWarning"

import styles from "./LogoIntegration.module.scss"

import type { LogoIntegrationProps } from "."

export const LOGO_INTEGRATIONS_BY_NAME = {
  github: IntegrationGitHub,
  jira: IntegrationJira,
  azure_boards: AzureBoardsLogo,
  asana: AsanaLogo,
  bitbucket: Bitbucket,
  ecr: Amazon,
  slack: Slack,
  wiz: Wiz,
  azure_repos: AzureRepos,
  gitlab: Gitlab,
  service_now: ServiceNow,
  splunk: Splunk,
  docker_hub: DockerHub,
  acr: ACR,
  gcr: GCR,
  serviceNow: ServiceNow,
  kodem_ci: KodemCI,
  kodem_cli: KodemCLI,
  kodem_mcp: KodemMCP,
  jenkins: Jenkins,
  circle_ci: CircleCI,
  github_actions: GithubActions,
  webhook: IntegrationWebhook,
  vscode: VSCode,
  visualstudio: VisualStudio,
  jetbrains: JetBrains,
  claude_code: ClaudeColored,
  cursor: Cursor,
  gemini_cli: GeminiCli,
  github_copilot: GitHubCopilot,
  antigravity: Antigravity,
  codex: Codex,
  package_registry: PackageRegistry
} as Record<string, React.FC>

export const LogoIntegration = ({
  className,
  name,
  isInstalled,
  onlyLogo,
  isEnabled,
  health,
  isHealthLoading
}: LogoIntegrationProps) => {
  const Logo = LOGO_INTEGRATIONS_BY_NAME[name]

  if (!Logo) return null

  const showStatus = !onlyLogo && isEnabled
  const showHealthLoading = showStatus && isInstalled && isHealthLoading
  const showHealth =
    showStatus && isInstalled && !isHealthLoading && isUnhealthy(health)
  const showInstallation = showStatus && !showHealthLoading && !showHealth

  return (
    <div className={cn(styles.logo, className)}>
      <Logo />
      {showHealth && (
        <HealthWarning
          health={health}
          icon={ExclamationCircleFilled}
          className={styles.healthBadge}
        />
      )}
      {showHealthLoading && (
        <span
          aria-label="installation-health-loading"
          className={styles.healthLoading}
        >
          <LoadingOutlined />
        </span>
      )}
      {showInstallation && (
        <IntegrationInstallationStatus
          isInstalled={isInstalled}
          classes={{ container: styles.link }}
        />
      )}
    </div>
  )
}
